import axios from "axios";
import Constants from "../../../components.constants.js";


export default {

  async getSessionUsersRequestedMetadataAssetsFromServer(context, payload = {}) {
    try {
      let resp = await axios.get(Constants.metadataRequestUrl, payload);
      if (Constants.acceptedStatusCodes.includes(resp.status)) {
        resp.data.statusCode = resp.status
        return resp.data;
      }else {
        throw `Response from server-->${resp.status}, data--->${resp.data}, statusText-->${resp.statusText}`;
      }
    } catch (error) {
      console.error(
        `[getSessionUsersRequestedMetadataAssetsFromServer][Store][Error occured while getting RequestedMetadataAssets--->${error}]`
      );
      if (error.response) {
        if (error.response.status == 401){
          return context.dispatch("users/logOutFromServer", {},{root:true})
        }
        else {
          error.response.data.statusCode = error.response.status
          return error.response.data
        }
      }
      return {}
    }
  },
  async getAllRequestedMetadataAssetsFromServer(context, payload = {}) {
    try {
      let resp = await axios.get(Constants.metadataApproverUrl, payload);
      if (Constants.acceptedStatusCodes.includes(resp.status)) {
        resp.data.statusCode = resp.status
        return resp.data;
      }else {
        throw `Response from server-->${resp.status}, data--->${resp.data}, statusText-->${resp.statusText}`;
      }
    } catch (error) {
      console.error(
        `[getAllRequestedMetadataAssetsFromServer][Store][Error occured while getting RequestedMetadataAssets--->${error}]`
      );
      if (error.response) {
        if (error.response.status == 401){
          return context.dispatch("users/logOutFromServer", {},{root:true})
        }
        else {
          error.response.data.statusCode = error.response.status
          return error.response.data
        }
      }
      return {}
    }
  },

  async addNewMetadataRequest(context, payload = {}) {
    //payload : FUSION Users JSON schema

    try {
      let resp = await axios.post(Constants.metadataRequestUrl, payload);
      if (Constants.acceptedStatusCodes.includes(resp.status)) {
        console.log(
          `[addNewMetadataRequest][Store][MetadataRequestorAsset add resp-->${resp.status}]`
        );
        resp.data.statusCode = resp.status
        return resp.data;
      } else {
        throw `Response from server-->${resp.status}, data--->${resp.data}, statusText-->${resp.statusText}`;
      }
    } catch (error) {
      console.error(
        `[addNewMetadataRequest][Store][Error occured while adding MetadataRequestorAsset--->${error}]`
      );
      if (error.response) {
        if (error.response.status == 401){
          return context.dispatch("users/logOutFromServer", {},{root:true})
        }
        else {
          error.response.data.statusCode = error.response.status
          return error.response.data
        }
      }
      return {}
    }

  },

  async updateMetadataRequestorAsset(context, payload = {}) {
    //payload : {params:{metadataProfileId: "23412123"}, data:DAM Users JSON schema}

    try {
      let resp = await axios.put(`${Constants.metadataApproverUrl}/${payload.params._id}`, payload);
      if (Constants.acceptedStatusCodes.includes(resp.status)) {
        console.log(
          `[updateMetadataRequestorAsset][Store][MetadataRequestorAsset update resp-->${resp.status}]`
        );
        resp.data.statusCode = resp.status
        return resp.data;
      } else {
        throw `Response from server-->${resp.status}, data--->${resp.data}, statusText-->${resp.statusText}`;
      }
    } catch (error) {
      console.error(
        `[updateMetadataRequestorAsset][Store][Error occured while updating MetadataRequestorAsset--->${error}]`
      );
      if (error.response) {
        if (error.response.status == 401){
          return context.dispatch("users/logOutFromServer", {},{root:true})
        }
        else {
          error.response.data.statusCode = error.response.status
          return error.response.data
        }
      }
      return {}
    }
  },

  async fetchRequesterComments(context, payload = {}){
    //payload : {params:{metadataProfileId: "23412123"}, data:DAM Users JSON schema}
    try {
      let resp = await axios.get(`${Constants.metadataRequestUrl}/${payload.params._id}/comments`,payload);
      if (Constants.acceptedStatusCodes.includes(resp.status)) {
        console.log(
          `[fetchRequesterComments][Store][MetadataRequestorAsset update resp-->${resp.status}]`
        );
        resp.data.statusCode = resp.status
        return resp.data;
      } else {
        throw `Response from server-->${resp.status}, data--->${resp.data}, statusText-->${resp.statusText}`;
      }
    } catch (error) {
      console.error(
        `[fetchRequesterComments][Store][Error occured while fetching Request comments--->${error}]`
      );
      if (error.response) {
        if (error.response.status == 401){
          return context.dispatch("users/logOutFromServer", {},{root:true})
        }
        else {
          error.response.data.statusCode = error.response.status
          return error.response.data
        }
      }
      return {}
    }
  },

  async fetchApproverComments(context, payload = {}){
    //payload : {params:{metadataProfileId: "23412123"}, data:DAM Users JSON schema}
    try {
      let resp = await axios.get(`${Constants.metadataApproverUrl}/${payload.params._id}/comments`,payload);
      if (Constants.acceptedStatusCodes.includes(resp.status)) {
        console.log(
          `[fetchApproverComments][Store][MetadataRequestorAsset update resp-->${resp.status}]`
        );
        resp.data.statusCode = resp.status
        return resp.data;
      } else {
        throw `Response from server-->${resp.status}, data--->${resp.data}, statusText-->${resp.statusText}`;
      }
    } catch (error) {
      console.error(
        `[fetchApproverComments][Store][Error occured while fetching Request comments--->${error}]`
      );
      if (error.response) {
        if (error.response.status == 401){
          return context.dispatch("users/logOutFromServer", {},{root:true})
        }
        else {
          error.response.data.statusCode = error.response.status
          return error.response.data
        }
      }
      return {}
    }
  },


  async addApproverComments(context, payload = {}){
    //payload : {params:{metadataProfileId: "23412123"}, data:DAM Users JSON schema}
    try {
      let resp = await axios.post(`${Constants.metadataApproverUrl}/${payload.params._id}/comments`,payload);
      if (Constants.acceptedStatusCodes.includes(resp.status)) {
        console.log(
          `[addApproverComments][Store][metadata request add new comments resp-->${resp.status}]`
        );
        resp.data.statusCode = resp.status
        return resp.data;
      } else {
        throw `Response from server-->${resp.status}, data--->${resp.data}, statusText-->${resp.statusText}`;
      }
    } catch (error) {
      console.error(
        `[addApproverComments][Store][Error occured while adding Request comments--->${error}]`
      );
      if (error.response) {
        if (error.response.status == 401){
          return context.dispatch("users/logOutFromServer", {},{root:true})
        }
        else {
          error.response.data.statusCode = error.response.status
          return error.response.data
        }
      }
      return {}
    }
  },

  async addRequestComments(context, payload = {}){
    //payload : {params:{metadataProfileId: "23412123"}, data:DAM Users JSON schema}
    try {
      let resp = await axios.post(`${Constants.metadataRequestUrl}/${payload.params._id}/comments`,payload);
      if (Constants.acceptedStatusCodes.includes(resp.status)) {
        console.log(
          `[addRequestComments][Store][metadata request add new comments resp-->${resp.status}]`
        );
        resp.data.statusCode = resp.status
        return resp.data;
      } else {
        throw `Response from server-->${resp.status}, data--->${resp.data}, statusText-->${resp.statusText}`;
      }
    } catch (error) {
      console.error(
        `[addRequestComments][Store][Error occured while adding Request comments--->${error}]`
      );
      if (error.response) {
        if (error.response.status == 401){
          return context.dispatch("users/logOutFromServer", {},{root:true})
        }
        else {
          error.response.data.statusCode = error.response.status
          return error.response.data
        }
      }
      return {}
    }
  },

  async updateApproverComment(context, payload = {}){
    //payload : {params:{metadataProfileId: "23412123"}, data:DAM Users JSON schema}
    try {
      let resp = await axios.put(`${Constants.metadataApproverUrl}/${payload.params._id}/comments/${payload.params.comment_id}`,payload);
      if (Constants.acceptedStatusCodes.includes(resp.status)) {
        console.log(
          `[updateApproverComment][Store][metadata request update comments resp-->${resp.status}]`
        );
        resp.data.statusCode = resp.status
        return resp.data;
      } else {
        throw `Response from server-->${resp.status}, data--->${resp.data}, statusText-->${resp.statusText}`;
      }
    } catch (error) {
      console.error(
        `[updateApproverComment][Store][Error occured while updating Request comments--->${error}]`
      );
      if (error.response) {
        if (error.response.status == 401){
          return context.dispatch("users/logOutFromServer", {},{root:true})
        }
        else {
          error.response.data.statusCode = error.response.status
          return error.response.data
        }
      }
      return {}
    }
  },
  async updateRequestMetadata(context, payload = {}){
    //payload : {params:{_id: "23412123"}, data:DAM Metadata request JSON schema}
    try {
      let resp = await axios.put(`${Constants.metadataRequestUrl}/${payload.params._id}`,payload);
      if (Constants.acceptedStatusCodes.includes(resp.status)) {
        console.log(
          `[updateRequestMetadata][Store][metadata request metadata update resp-->${resp.status}]`
        );
        resp.data.statusCode = resp.status
        return resp.data;
      } else {
        throw `Response from server-->${resp.status}, data--->${resp.data}, statusText-->${resp.statusText}`;
      }
    } catch (error) {
      console.error(
        `[updateRequestMetadata][Store][Error occured while updating Request metadata--->${error}]`
      );
      if (error.response) {
        if (error.response.status == 401){
          return context.dispatch("users/logOutFromServer", {},{root:true})
        }
        else {
          error.response.data.statusCode = error.response.status
          return error.response.data
        }
      }
      return {}
    }
  },
  async updateRequesterComment(context, payload = {}){
    //payload : {params:{metadataProfileId: "23412123"}, data:DAM Users JSON schema}
    try {
      let resp = await axios.put(`${Constants.metadataRequestUrl}/${payload.params._id}/comments/${payload.params.comment_id}`,payload);
      if (Constants.acceptedStatusCodes.includes(resp.status)) {
        console.log(
          `[updateRequesterComments][Store][metadata request comments update resp-->${resp.status}]`
        );
        resp.data.statusCode = resp.status
        return resp.data;
      } else {
        throw `Response from server-->${resp.status}, data--->${resp.data}, statusText-->${resp.statusText}`;
      }
    } catch (error) {
      console.error(
        `[updateRequesterComments][Store][Error occured while updating Request comments--->${error}]`
      );
      if (error.response) {
        if (error.response.status == 401){
          return context.dispatch("users/logOutFromServer", {},{root:true})
        }
        else {
          error.response.data.statusCode = error.response.status
          return error.response.data
        }
      }
      return {}
    }
  },
  async deleteApproverComment(context, payload = {}){
    //payload : {params:{metadataProfileId: "23412123"}, data:DAM Users JSON schema}
    try {
      let resp = await axios.delete(`${Constants.metadataApproverUrl}/${payload.params._id}/comments/${payload.params.comment_id}`,payload);
      if (Constants.acceptedStatusCodes.includes(resp.status)) {
        console.log(
          `[deleteApproverComment][Store][metadata request delete comments resp-->${resp.status}]`
        );
        resp.data.statusCode = resp.status
        return resp.data;
      } else {
        throw `Response from server-->${resp.status}, data--->${resp.data}, statusText-->${resp.statusText}`;
      }
    } catch (error) {
      console.error(
        `[deleteApproverComment][Store][Error occured while deleting Request comments--->${error}]`
      );
      if (error.response) {
        if (error.response.status == 401){
          return context.dispatch("users/logOutFromServer", {},{root:true})
        }
        else {
          error.response.data.statusCode = error.response.status
          return error.response.data
        }
      }
      return {}
    }
  },

  async deleteRequestComment(context, payload = {}){
    //payload : {params:{metadataProfileId: "23412123"}, data:DAM Users JSON schema}
    try {
      let resp = await axios.delete(`${Constants.metadataRequestUrl}/${payload.params._id}/comments/${payload.params.comment_id}`,payload);
      if (Constants.acceptedStatusCodes.includes(resp.status)) {
        console.log(
          `[deleteRequestComment][Store][metadata request delete comments resp-->${resp.status}]`
        );
        resp.data.statusCode = resp.status
        return resp.data;
      } else {
        throw `Response from server-->${resp.status}, data--->${resp.data}, statusText-->${resp.statusText}`;
      }
    } catch (error) {
      console.error(
        `[deleteRequestComment][Store][Error occured while deleting Request comments--->${error}]`
      );
      if (error.response) {
        if (error.response.status == 401){
          return context.dispatch("users/logOutFromServer", {},{root:true})
        }
        else {
          error.response.data.statusCode = error.response.status
          return error.response.data
        }
      }
      return {}
    }
  },

  async getRequestedMetadataAssetInfoFromServer(context, payload = {}) {
    try {
      let resp = await axios.get(`${Constants.metadataRequestUrl}/${payload.params._id}`);
      if (Constants.acceptedStatusCodes.includes(resp.status)) {
        resp.data.statusCode = resp.status
        return resp.data;
      } else {
        throw `Response from server-->${resp.status}, data--->${resp.data}, statusText-->${resp.statusText}`;
      }
    } catch (error) {
      console.error(
        `[getRequestedMetadataAssetInfoFromServer][Store][Error occured while getting Metadata approver asset info --->${error}]`
      );
      if (error.response) {
        if (error.response.status == 401){
          return context.dispatch("users/logOutFromServer", {},{root:true})
        }
        else {
          error.response.data.statusCode = error.response.status
          return error.response.data
        }
      }
      return {}
    }
  },
  async getApproverBasedRequestedInfoFromServer(context, payload = {}) {
    try {
      let resp = await axios.get(`${Constants.metadataApproverUrl}/${payload.params._id}`);
      if (Constants.acceptedStatusCodes.includes(resp.status)) {
        resp.data.statusCode = resp.status
        return resp.data;
      } else {
        throw `Response from server-->${resp.status}, data--->${resp.data}, statusText-->${resp.statusText}`;
      }
    } catch (error) {
      console.error(
        `[getApproverBasedRequestedInfoFromServer][Store][Error occured while getting Metadata approver asset info --->${error}]`
      );
      if (error.response) {
        if (error.response.status == 401){
          return context.dispatch("users/logOutFromServer", {},{root:true})
        }
        else {
          error.response.data.statusCode = error.response.status
          return error.response.data
        }
      }
      return {}
    }
  },
};
